//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as mailDraftAction from '../action/mailDraftAction';
import * as bestpartnerAction from '../action/bestpartnerAction';
import * as helpAction from '../action/helpAction';
//Material-ui
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
//Add
import Masonry from 'react-masonry-component';
//Func
import atom2datetime from '../func/atom2datetime';
//Part
import PartUserMainImg from './PartUserMainImg';
import PartUserName from './PartUserName';
import PartPagingNextPrev from './PartPagingNextPrev';

import PartTimeIcon from './PartTimeIcon';

//Icon
import RefreshIcon from '@material-ui/icons/Refresh';
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';

//image
import iconIntroduction from '../img/icon/icon_introduction.jpg';


class Comp extends React.Component {

  constructor(props) {
    super(props);
  	this.state = {
      bestpartnerDelId: null,
      bestpartnerDelAnchor: null,
  	}
  }

  componentDidMount() {
    document.title = 'ベストパートナーの紹介 - パートナーズ';
    if (this.props.history.action === 'PUSH' || !this.props.bestpartner.datetime) {
      this.props.bestpartnerListGet(1);
      window.scrollTo(0, 0);
    }
  }

  _bestpartnerOpen(mailId) {
    let index = this.props.bestpartner.list.findIndex((v) => v.mail_id === mailId);
		if (index >= 0) {
      let item = this.props.bestpartner.list[index];
			if (item.mail_unconfirmed_mail === 1) {
        this.props.bestpartnerRead(mailId);
      }
			this.props.history.push({ pathname: '/partner/' + item.userdata_id_code });
		}
  }


  _bestpartnerDel(pic) {
    this.props.bestpartnerItemDel(pic);
    this.setState({bestpartnerDelId: null})
  }

  _onPaging(page) {
    this.props.bestpartnerListGet(page);
    window.scrollTo(0, 0);
  }

  _renderList = (item, index) => {


		return (
      <div key={index} className='box_outer'>
        <Box className='box_innner round12' boxShadow={2}>

          {
            (item.mail_unconfirmed_mail === 1) && (
              <div
                className='ribbon_orange'
                style={{position:'absolute', top:'0px', left:'0px'}}
              >
                未読
              </div>
            )
          }
          <div style={{padding:'2%'}}>
            <div style={{textAlign:'center'}}>
              <div
                style={{cursor:'pointer'}}
                onClick={ () => this._bestpartnerOpen(item.mail_id) }
              >
                <PartUserName
                  data={{
                    name: item.userdata_name,
                    sex: item.userdata_sex,
                    size: '1.4em',
                  }}
                />
              </div>
              <div>
                {item.userdata_age}才 {item.userdata_prof_region}
              </div>
            </div>
            <div className='box_left'>
              <div style={{margin:'1%'}}>
                <div
                  style={{cursor:'pointer'}}
                  onClick={ () => this._bestpartnerOpen(item.mail_id) }
                >
                  <div align='center'>
                    <PartUserMainImg
                      mainImg={item.userdata_mainImg}
                      maxWidth={'160px'}
                      width={'100%'}
                      height={'auto'}
                      radius={'50%'}
                      lazyLoad={false}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='box_right'>
              {
                (item.userdata_attestation === 1 && item.userdata_service_stop === 0) ? (
                  <div>
                    {
                      (item.userdata_prof_partner_comment.length > 0) &&
                      <div
                        className='comment round12'
                        style={{fontSize:'0.9em', color:'#666', margin:'1%'}}
                      >
                        {item.userdata_prof_partner_comment}
                      </div>
                    }
                    { (item.userdata_proof_person === 1) && (<span className='proof_icon'>本人証明</span>) }
                    { (item.userdata_proof_photo === 1) && (<span className='proof_icon'>写真証明</span>) }
                    { (item.userdata_proof_income === 1) && (<span className='proof_icon'>収入証明</span>) }
                    { (item.userdata_proof_single === 1) && (<span className='proof_icon'>独身証明</span>) }
                    { (item.userdata_proof_credit === 1) && (<span className='proof_icon'>ｸﾚｼﾞｯﾄ証明</span>) }
                    { (item.post_count > 0) && (<span className='post_icon'>投稿 {item.post_count}件</span>) }
                    { (item.qa_count > 0 || item.qa_answer_count > 0) && (
                      <span className='qa_icon'>Q&A
                        { (item.qa_count > 0) && (item.qa_count + '問')}
                        { (item.qa_answer_count > 0) && (item.qa_answer_count + '答')}
                      </span>
                    ) }
                    { (item.character_type16) && (<span className='personality_icon'>性格</span>) }
                  </div>
                ) : (
                  <div>
                    <div
                      className='comment round12'
                      style={{fontSize:'0.8em', color:'#999', margin:'1%'}}
                    >
                      ご紹介は停止、退会されていない方だけが対象となりますが、お相手様の事情により
                      停止、退会されている場合がございます。<br/>
                      何卒ご理解賜りますようお願い申し上げます
                    </div>
                  </div>
                )
              }

            </div>

            <div style={{clear:'both'}} />


            <div style={{textAlign:'center'}}>
              <PartTimeIcon
                text={atom2datetime(item.mail_transmission_datetime_atom, 'D') + ' 紹介'}
              />
            </div>
          </div>

          <div style={{position:'absolute', top:'0px', right:'0px'}}>
            <IconButton
              onClick={ (event) => this.setState({bestpartnerDelId:item.mail_id, bestpartnerDelAnchor:event.currentTarget}) }
            >
              <MoreVertSharpIcon
                style={{fontSize:'1.2em',color:'#999'}}
              />
            </IconButton>
          </div>

        </Box>
      </div>
    );
  };



	render() {
		return (
      <div>
        <h1 align='center'>ベストパートナー紹介</h1>

        {
          (this.props.bestpartner.datetime) && (
            <div id="user_list_block">
              {
                (this.props.bestpartner.list.length > 0) ? (
                  <div>
                    <div
                      style={{
                        display:'flex',
                        flexDirection:'row',
                        alignItems:'center',
                        justifyContent: 'space-between',
                        margin: '10px',
                      }}
                    >
                      <div>
                      </div>

                      <div>
                        <span style={{color:'#666'}}>ページ{this.props.bestpartner.page}</span>

                        <IconButton
                          onClick={ () => this.props.bestpartnerListGet(1) }
                        >
                          <RefreshIcon />
                        </IconButton>
                      </div>
                    </div>
                    <Masonry options={{
                      itemSelector: '.box_outer',
                      transitionDuration: 0,
                    }}>
                      {
                        this.props.bestpartner.list.map(
                          (value, index, arr) => this._renderList(value, index, arr)
                        )
                      }
                    </Masonry>
                    <div style={{margin:'15px'}}>
                      <PartPagingNextPrev
                        page={this.props.bestpartner.page}
                        isNext={this.props.bestpartner.isListNext}
                        onClick={ (e) => this._onPaging(e) }
                        style={{margin:'15px'}}
                      />
                    </div>
                  </div>
                ) : (
                  <div>
                    <h2 align='center' style={{padding:'10px 0px'}}>
                      <span className='i-b'>ベストパートナーの紹介は</span>
                      <span className='i-b'>見つかりませんでした</span>
                    </h2>

                    {
                      (this.props.my.proof.person === 0) && (
                        <div style={{margin:'10px'}} align='center'>
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={ () => this.props.history.push('/my/proof/person') }
                          >
                            ベストパートナーの紹介には、本人証明の申請が必要です
                          </Button>
                        </div>

                      )

                    }

                    <div style={{margin:'10px'}} align='center'>
                      <img
                        src={iconIntroduction }
                        style={{
                          maxWidth:'200px',
                          width:'100%',
                          height:'auto',
                          borderRadius: '50%',
                        }}
                        alt=''
                      />
                    </div>
                    <div style={{maxWidth:'400px', margin:'auto'}} align='center'>
                      <span className='i-b'>プロフィールの希望条件の一致率、</span>
                      <span className='i-b'>性格の相性、メールの状況、距離などを</span>
                      <span className='i-b'>考慮してご紹介させていただく機能です</span>
                    </div>
                  </div>
                )
              }
            </div>
          )
        }

        <div align='center' style={{margin:'15px'}}>
          <Button
            color="primary"
            variant={ "outlined" }
            onClick={ () => this.props.helpOpen('category','introduction') }
          >
            ベストパートナー紹介とは？
          </Button>
        </div>

        <Menu
          anchorEl={this.state.bestpartnerDelAnchor}
          keepMounted
          open={(this.state.bestpartnerDelId)? true: false}
          onClick={ () => this.setState({bestpartnerDelId: null}) }
        >
          <MenuItem
            onClick={ () => {
              this._bestpartnerDel(this.state.bestpartnerDelId);
              this.setState({bestpartnerDelDelAnchor:null, bestpartnerDelId:null});
            }}
          >
            <div>
              ベストパートナーの紹介を削除する
            </div>
          </MenuItem>
        </Menu>
      </div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
    bestpartner: state.bestpartner,
    my: state.my
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		...mailDraftAction,
    ...bestpartnerAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
